import { Country } from "../Country.js";
import { Locale, type LocalizedString } from "../Locale.js";

export const countryNameMap: Record<Country, LocalizedString> = {
	[Country.Afghanistan]: {
		[Locale.cs]: "Afghánistán",
		[Locale.en]: "Afghanistan",
	},
	[Country.Albania]: {
		[Locale.cs]: "Albánie",
		[Locale.en]: "Albania",
	},
	[Country.Algeria]: {
		[Locale.cs]: "Alžírsko",
		[Locale.en]: "Algeria",
	},
	[Country.Andorra]: {
		[Locale.cs]: "Andorra",
		[Locale.en]: "Andorra",
	},
	[Country.Angola]: {
		[Locale.cs]: "Angola",
		[Locale.en]: "Angola",
	},
	[Country.AntiguaAndBarbuda]: {
		[Locale.cs]: "Antigua a Barbuda",
		[Locale.en]: "Antigua and Barbuda",
	},
	[Country.Argentina]: {
		[Locale.cs]: "Argentina",
		[Locale.en]: "Argentina",
	},
	[Country.Armenia]: {
		[Locale.cs]: "Arménie",
		[Locale.en]: "Armenia",
	},
	[Country.Australia]: {
		[Locale.cs]: "Austrálie",
		[Locale.en]: "Australia",
	},
	[Country.Austria]: {
		[Locale.cs]: "Rakousko",
		[Locale.en]: "Austria",
	},
	[Country.Azerbaijan]: {
		[Locale.cs]: "Ázerbájdžán",
		[Locale.en]: "Azerbaijan",
	},
	[Country.Bahamas]: {
		[Locale.cs]: "Bahamy",
		[Locale.en]: "Bahamas",
	},
	[Country.Bahrain]: {
		[Locale.cs]: "Bahrajn",
		[Locale.en]: "Bahrain",
	},
	[Country.Bangladesh]: {
		[Locale.cs]: "Bangladéš",
		[Locale.en]: "Bangladesh",
	},
	[Country.Barbados]: {
		[Locale.cs]: "Barbados",
		[Locale.en]: "Barbados",
	},
	[Country.Belarus]: {
		[Locale.cs]: "Bělorusko",
		[Locale.en]: "Belarus",
	},
	[Country.Belgium]: {
		[Locale.cs]: "Belgie",
		[Locale.en]: "Belgium",
	},
	[Country.Belize]: {
		[Locale.cs]: "Belize",
		[Locale.en]: "Belize",
	},
	[Country.Benin]: {
		[Locale.cs]: "Benin",
		[Locale.en]: "Benin",
	},
	[Country.Bhutan]: {
		[Locale.cs]: "Bhútán",
		[Locale.en]: "Bhutan",
	},
	[Country.Bolivia]: {
		[Locale.cs]: "Bolívie",
		[Locale.en]: "Bolivia",
	},
	[Country.BosniaAndHerzegovina]: {
		[Locale.cs]: "Bosna a Hercegovina",
		[Locale.en]: "Bosnia and Herzegovina",
	},
	[Country.Botswana]: {
		[Locale.cs]: "Botswana",
		[Locale.en]: "Botswana",
	},
	[Country.Brazil]: {
		[Locale.cs]: "Brazílie",
		[Locale.en]: "Brazil",
	},
	[Country.Brunei]: {
		[Locale.cs]: "Brunej",
		[Locale.en]: "Brunei",
	},
	[Country.Bulgaria]: {
		[Locale.cs]: "Bulharsko",
		[Locale.en]: "Bulgaria",
	},
	[Country.BurkinaFaso]: {
		[Locale.cs]: "Burkina Faso",
		[Locale.en]: "Burkina Faso",
	},
	[Country.Burundi]: {
		[Locale.cs]: "Burundi",
		[Locale.en]: "Burundi",
	},
	[Country.CaboVerde]: {
		[Locale.cs]: "Kapverdy",
		[Locale.en]: "Cabo Verde",
	},
	[Country.Cambodia]: {
		[Locale.cs]: "Kambodža",
		[Locale.en]: "Cambodia",
	},
	[Country.Cameroon]: {
		[Locale.cs]: "Kamerun",
		[Locale.en]: "Cameroon",
	},
	[Country.Canada]: {
		[Locale.cs]: "Kanada",
		[Locale.en]: "Canada",
	},
	[Country.CentralAfricanRepublic]: {
		[Locale.cs]: "Středoafrická republika",
		[Locale.en]: "Central African Republic",
	},
	[Country.Chad]: {
		[Locale.cs]: "Čad",
		[Locale.en]: "Chad",
	},
	[Country.Chile]: {
		[Locale.cs]: "Chile",
		[Locale.en]: "Chile",
	},
	[Country.China]: {
		[Locale.cs]: "Čína",
		[Locale.en]: "China",
	},
	[Country.Colombia]: {
		[Locale.cs]: "Kolumbie",
		[Locale.en]: "Colombia",
	},
	[Country.Comoros]: {
		[Locale.cs]: "Komory",
		[Locale.en]: "Comoros",
	},
	[Country.Congo]: {
		[Locale.cs]: "Kongo",
		[Locale.en]: "Congo",
	},
	[Country.CostaRica]: {
		[Locale.cs]: "Kostarika",
		[Locale.en]: "Costa Rica",
	},
	[Country.CoteDIvoire]: {
		[Locale.cs]: "Pobřeží slonoviny",
		[Locale.en]: "Côte d'Ivoire",
	},
	[Country.Croatia]: {
		[Locale.cs]: "Chorvatsko",
		[Locale.en]: "Croatia",
	},
	[Country.Cuba]: {
		[Locale.cs]: "Kuba",
		[Locale.en]: "Cuba",
	},
	[Country.Cyprus]: {
		[Locale.cs]: "Kypr",
		[Locale.en]: "Cyprus",
	},
	[Country.Czechia]: {
		[Locale.cs]: "Česko",
		[Locale.en]: "Czechia",
	},
	[Country.DemocraticRepublicOfTheCongo]: {
		[Locale.cs]: "Demokratická republika Kongo",
		[Locale.en]: "Democratic Republic of the Congo",
	},
	[Country.Denmark]: {
		[Locale.cs]: "Dánsko",
		[Locale.en]: "Denmark",
	},
	[Country.Djibouti]: {
		[Locale.cs]: "Džibutsko",
		[Locale.en]: "Djibouti",
	},
	[Country.Dominica]: {
		[Locale.cs]: "Dominika",
		[Locale.en]: "Dominica",
	},
	[Country.DominicanRepublic]: {
		[Locale.cs]: "Dominikánská republika",
		[Locale.en]: "Dominican Republic",
	},
	[Country.Ecuador]: {
		[Locale.cs]: "Ekvádor",
		[Locale.en]: "Ecuador",
	},
	[Country.Egypt]: {
		[Locale.cs]: "Egypt",
		[Locale.en]: "Egypt",
	},
	[Country.ElSalvador]: {
		[Locale.cs]: "Salvador",
		[Locale.en]: "El Salvador",
	},
	[Country.EquatorialGuinea]: {
		[Locale.cs]: "Rovníková Guinea",
		[Locale.en]: "Equatorial Guinea",
	},
	[Country.Eritrea]: {
		[Locale.cs]: "Eritrea",
		[Locale.en]: "Eritrea",
	},
	[Country.Estonia]: {
		[Locale.cs]: "Estonsko",
		[Locale.en]: "Estonia",
	},
	[Country.Eswatini]: {
		[Locale.cs]: "Eswatini",
		[Locale.en]: "Eswatini",
	},
	[Country.Ethiopia]: {
		[Locale.cs]: "Etiopie",
		[Locale.en]: "Ethiopia",
	},
	[Country.Fiji]: {
		[Locale.cs]: "Fidži",
		[Locale.en]: "Fiji",
	},
	[Country.Finland]: {
		[Locale.cs]: "Finsko",
		[Locale.en]: "Finland",
	},
	[Country.France]: {
		[Locale.cs]: "Francie",
		[Locale.en]: "France",
	},
	[Country.Gabon]: {
		[Locale.cs]: "Gabon",
		[Locale.en]: "Gabon",
	},
	[Country.Gambia]: {
		[Locale.cs]: "Gambie",
		[Locale.en]: "Gambia",
	},
	[Country.Georgia]: {
		[Locale.cs]: "Gruzie",
		[Locale.en]: "Georgia",
	},
	[Country.Germany]: {
		[Locale.cs]: "Německo",
		[Locale.en]: "Germany",
	},
	[Country.Ghana]: {
		[Locale.cs]: "Ghana",
		[Locale.en]: "Ghana",
	},
	[Country.Greece]: {
		[Locale.cs]: "Řecko",
		[Locale.en]: "Greece",
	},
	[Country.Grenada]: {
		[Locale.cs]: "Grenada",
		[Locale.en]: "Grenada",
	},
	[Country.Guatemala]: {
		[Locale.cs]: "Guatemala",
		[Locale.en]: "Guatemala",
	},
	[Country.Guinea]: {
		[Locale.cs]: "Guinea",
		[Locale.en]: "Guinea",
	},
	[Country.GuineaBissau]: {
		[Locale.cs]: "Guinea-Bissau",
		[Locale.en]: "Guinea-Bissau",
	},
	[Country.Guyana]: {
		[Locale.cs]: "Guyana",
		[Locale.en]: "Guyana",
	},
	[Country.Haiti]: {
		[Locale.cs]: "Haiti",
		[Locale.en]: "Haiti",
	},
	[Country.Honduras]: {
		[Locale.cs]: "Honduras",
		[Locale.en]: "Honduras",
	},
	[Country.Hungary]: {
		[Locale.cs]: "Maďarsko",
		[Locale.en]: "Hungary",
	},
	[Country.Iceland]: {
		[Locale.cs]: "Island",
		[Locale.en]: "Iceland",
	},
	[Country.India]: {
		[Locale.cs]: "Indie",
		[Locale.en]: "India",
	},
	[Country.Indonesia]: {
		[Locale.cs]: "Indonésie",
		[Locale.en]: "Indonesia",
	},
	[Country.Iran]: {
		[Locale.cs]: "Írán",
		[Locale.en]: "Iran",
	},
	[Country.Iraq]: {
		[Locale.cs]: "Irák",
		[Locale.en]: "Iraq",
	},
	[Country.Ireland]: {
		[Locale.cs]: "Irsko",
		[Locale.en]: "Ireland",
	},
	[Country.Israel]: {
		[Locale.cs]: "Izrael",
		[Locale.en]: "Israel",
	},
	[Country.Italy]: {
		[Locale.cs]: "Itálie",
		[Locale.en]: "Italy",
	},
	[Country.Jamaica]: {
		[Locale.cs]: "Jamajka",
		[Locale.en]: "Jamaica",
	},
	[Country.Japan]: {
		[Locale.cs]: "Japonsko",
		[Locale.en]: "Japan",
	},
	[Country.Jordan]: {
		[Locale.cs]: "Jordánsko",
		[Locale.en]: "Jordan",
	},
	[Country.Kazakhstan]: {
		[Locale.cs]: "Kazachstán",
		[Locale.en]: "Kazakhstan",
	},
	[Country.Kenya]: {
		[Locale.cs]: "Keňa",
		[Locale.en]: "Kenya",
	},
	[Country.Kiribati]: {
		[Locale.cs]: "Kiribati",
		[Locale.en]: "Kiribati",
	},
	[Country.Kuwait]: {
		[Locale.cs]: "Kuvajt",
		[Locale.en]: "Kuwait",
	},
	[Country.Kyrgyzstan]: {
		[Locale.cs]: "Kyrgyzstán",
		[Locale.en]: "Kyrgyzstan",
	},
	[Country.Laos]: {
		[Locale.cs]: "Laos",
		[Locale.en]: "Laos",
	},
	[Country.Latvia]: {
		[Locale.cs]: "Lotyšsko",
		[Locale.en]: "Latvia",
	},
	[Country.Lebanon]: {
		[Locale.cs]: "Libanon",
		[Locale.en]: "Lebanon",
	},
	[Country.Lesotho]: {
		[Locale.cs]: "Lesotho",
		[Locale.en]: "Lesotho",
	},
	[Country.Liberia]: {
		[Locale.cs]: "Libérie",
		[Locale.en]: "Liberia",
	},
	[Country.Libya]: {
		[Locale.cs]: "Libye",
		[Locale.en]: "Libya",
	},
	[Country.Liechtenstein]: {
		[Locale.cs]: "Lichtenštejnsko",
		[Locale.en]: "Liechtenstein",
	},
	[Country.Lithuania]: {
		[Locale.cs]: "Litva",
		[Locale.en]: "Lithuania",
	},
	[Country.Luxembourg]: {
		[Locale.cs]: "Lucembursko",
		[Locale.en]: "Luxembourg",
	},
	[Country.Madagascar]: {
		[Locale.cs]: "Madagaskar",
		[Locale.en]: "Madagascar",
	},
	[Country.Malawi]: {
		[Locale.cs]: "Malawi",
		[Locale.en]: "Malawi",
	},
	[Country.Malaysia]: {
		[Locale.cs]: "Malajsie",
		[Locale.en]: "Malaysia",
	},
	[Country.Maldives]: {
		[Locale.cs]: "Maledivy",
		[Locale.en]: "Maldives",
	},
	[Country.Mali]: {
		[Locale.cs]: "Mali",
		[Locale.en]: "Mali",
	},
	[Country.Malta]: {
		[Locale.cs]: "Malta",
		[Locale.en]: "Malta",
	},
	[Country.MarshallIslands]: {
		[Locale.cs]: "Marshallovy ostrovy",
		[Locale.en]: "Marshall Islands",
	},
	[Country.Mauritania]: {
		[Locale.cs]: "Mauritánie",
		[Locale.en]: "Mauritania",
	},
	[Country.Mauritius]: {
		[Locale.cs]: "Mauricius",
		[Locale.en]: "Mauritius",
	},
	[Country.Mexico]: {
		[Locale.cs]: "Mexiko",
		[Locale.en]: "Mexico",
	},
	[Country.Micronesia]: {
		[Locale.cs]: "Mikronésie",
		[Locale.en]: "Micronesia",
	},
	[Country.Moldova]: {
		[Locale.cs]: "Moldavsko",
		[Locale.en]: "Moldova",
	},
	[Country.Monaco]: {
		[Locale.cs]: "Monako",
		[Locale.en]: "Monaco",
	},
	[Country.Mongolia]: {
		[Locale.cs]: "Mongolsko",
		[Locale.en]: "Mongolia",
	},
	[Country.Montenegro]: {
		[Locale.cs]: "Černá Hora",
		[Locale.en]: "Montenegro",
	},
	[Country.Morocco]: {
		[Locale.cs]: "Maroko",
		[Locale.en]: "Morocco",
	},
	[Country.Mozambique]: {
		[Locale.cs]: "Mosambik",
		[Locale.en]: "Mozambique",
	},
	[Country.Myanmar]: {
		[Locale.cs]: "Myanmar",
		[Locale.en]: "Myanmar",
	},
	[Country.Namibia]: {
		[Locale.cs]: "Namibie",
		[Locale.en]: "Namibia",
	},
	[Country.Nauru]: {
		[Locale.cs]: "Nauru",
		[Locale.en]: "Nauru",
	},
	[Country.Nepal]: {
		[Locale.cs]: "Nepál",
		[Locale.en]: "Nepal",
	},
	[Country.Netherlands]: {
		[Locale.cs]: "Nizozemsko",
		[Locale.en]: "Netherlands",
	},
	[Country.NewZealand]: {
		[Locale.cs]: "Nový Zéland",
		[Locale.en]: "New Zealand",
	},
	[Country.Nicaragua]: {
		[Locale.cs]: "Nikaragua",
		[Locale.en]: "Nicaragua",
	},
	[Country.Niger]: {
		[Locale.cs]: "Niger",
		[Locale.en]: "Niger",
	},
	[Country.Nigeria]: {
		[Locale.cs]: "Nigérie",
		[Locale.en]: "Nigeria",
	},
	[Country.NorthKorea]: {
		[Locale.cs]: "Severní Korea",
		[Locale.en]: "North Korea",
	},
	[Country.NorthMacedonia]: {
		[Locale.cs]: "Severní Makedonie",
		[Locale.en]: "North Macedonia",
	},
	[Country.Norway]: {
		[Locale.cs]: "Norsko",
		[Locale.en]: "Norway",
	},
	[Country.Oman]: {
		[Locale.cs]: "Omán",
		[Locale.en]: "Oman",
	},
	[Country.Pakistan]: {
		[Locale.cs]: "Pákistán",
		[Locale.en]: "Pakistan",
	},
	[Country.Palau]: {
		[Locale.cs]: "Palau",
		[Locale.en]: "Palau",
	},
	[Country.Panama]: {
		[Locale.cs]: "Panama",
		[Locale.en]: "Panama",
	},
	[Country.PapuaNewGuinea]: {
		[Locale.cs]: "Papua Nová Guinea",
		[Locale.en]: "Papua New Guinea",
	},
	[Country.Paraguay]: {
		[Locale.cs]: "Paraguay",
		[Locale.en]: "Paraguay",
	},
	[Country.Peru]: {
		[Locale.cs]: "Peru",
		[Locale.en]: "Peru",
	},
	[Country.Philippines]: {
		[Locale.cs]: "Filipíny",
		[Locale.en]: "Philippines",
	},
	[Country.Poland]: {
		[Locale.cs]: "Polsko",
		[Locale.en]: "Poland",
	},
	[Country.Portugal]: {
		[Locale.cs]: "Portugalsko",
		[Locale.en]: "Portugal",
	},
	[Country.Qatar]: {
		[Locale.cs]: "Katar",
		[Locale.en]: "Qatar",
	},
	[Country.Romania]: {
		[Locale.cs]: "Rumunsko",
		[Locale.en]: "Romania",
	},
	[Country.Russia]: {
		[Locale.cs]: "Rusko",
		[Locale.en]: "Russia",
	},
	[Country.Rwanda]: {
		[Locale.cs]: "Rwanda",
		[Locale.en]: "Rwanda",
	},
	[Country.SaintKittsAndNevis]: {
		[Locale.cs]: "Svatý Kryštof a Nevis",
		[Locale.en]: "Saint Kitts and Nevis",
	},
	[Country.SaintLucia]: {
		[Locale.cs]: "Svatá Lucie",
		[Locale.en]: "Saint Lucia",
	},
	[Country.SaintVincentAndTheGrenadines]: {
		[Locale.cs]: "Svatý Vincenc a Grenadiny",
		[Locale.en]: "Saint Vincent and the Grenadines",
	},
	[Country.Samoa]: {
		[Locale.cs]: "Samoa",
		[Locale.en]: "Samoa",
	},
	[Country.SanMarino]: {
		[Locale.cs]: "San Marino",
		[Locale.en]: "San Marino",
	},
	[Country.SaoTomeAndPrincipe]: {
		[Locale.cs]: "Svatý Tomáš a Princův ostrov",
		[Locale.en]: "Sao Tome and Principe",
	},
	[Country.SaudiArabia]: {
		[Locale.cs]: "Saúdská Arábie",
		[Locale.en]: "Saudi Arabia",
	},
	[Country.Senegal]: {
		[Locale.cs]: "Senegal",
		[Locale.en]: "Senegal",
	},
	[Country.Serbia]: {
		[Locale.cs]: "Srbsko",
		[Locale.en]: "Serbia",
	},
	[Country.Seychelles]: {
		[Locale.cs]: "Seychely",
		[Locale.en]: "Seychelles",
	},
	[Country.SierraLeone]: {
		[Locale.cs]: "Sierra Leone",
		[Locale.en]: "Sierra Leone",
	},
	[Country.Singapore]: {
		[Locale.cs]: "Singapur",
		[Locale.en]: "Singapore",
	},
	[Country.Slovakia]: {
		[Locale.cs]: "Slovensko",
		[Locale.en]: "Slovakia",
	},
	[Country.Slovenia]: {
		[Locale.cs]: "Slovinsko",
		[Locale.en]: "Slovenia",
	},
	[Country.SolomonIslands]: {
		[Locale.cs]: "Šalamounovy ostrovy",
		[Locale.en]: "Solomon Islands",
	},
	[Country.Somalia]: {
		[Locale.cs]: "Somálsko",
		[Locale.en]: "Somalia",
	},
	[Country.SouthAfrica]: {
		[Locale.cs]: "Jihoafrická republika",
		[Locale.en]: "South Africa",
	},
	[Country.SouthKorea]: {
		[Locale.cs]: "Jižní Korea",
		[Locale.en]: "South Korea",
	},
	[Country.SouthSudan]: {
		[Locale.cs]: "Jižní Súdán",
		[Locale.en]: "South Sudan",
	},
	[Country.Spain]: {
		[Locale.cs]: "Španělsko",
		[Locale.en]: "Spain",
	},
	[Country.SriLanka]: {
		[Locale.cs]: "Šrí Lanka",
		[Locale.en]: "Sri Lanka",
	},
	[Country.Sudan]: {
		[Locale.cs]: "Súdán",
		[Locale.en]: "Sudan",
	},
	[Country.Suriname]: {
		[Locale.cs]: "Surinam",
		[Locale.en]: "Suriname",
	},
	[Country.Sweden]: {
		[Locale.cs]: "Švédsko",
		[Locale.en]: "Sweden",
	},
	[Country.Switzerland]: {
		[Locale.cs]: "Švýcarsko",
		[Locale.en]: "Switzerland",
	},
	[Country.Syria]: {
		[Locale.cs]: "Sýrie",
		[Locale.en]: "Syria",
	},
	[Country.Taiwan]: {
		[Locale.cs]: "Tchaj-wa",
		[Locale.en]: "Taiwan",
	},
	[Country.Tajikistan]: {
		[Locale.cs]: "Tádžikistán",
		[Locale.en]: "Tajikistan",
	},
	[Country.Tanzania]: {
		[Locale.cs]: "Tanzanie",
		[Locale.en]: "Tanzania",
	},
	[Country.Thailand]: {
		[Locale.cs]: "Thajsko",
		[Locale.en]: "Thailand",
	},
	[Country.TimorLeste]: {
		[Locale.cs]: "Východní Timor",
		[Locale.en]: "Timor-Leste",
	},
	[Country.Togo]: {
		[Locale.cs]: "Togo",
		[Locale.en]: "Togo",
	},
	[Country.Tonga]: {
		[Locale.cs]: "Tonga",
		[Locale.en]: "Tonga",
	},
	[Country.TrinidadAndTobago]: {
		[Locale.cs]: "Trinidad a Tobago",
		[Locale.en]: "Trinidad and Tobago",
	},
	[Country.Tunisia]: {
		[Locale.cs]: "Tunisko",
		[Locale.en]: "Tunisia",
	},
	[Country.Turkey]: {
		[Locale.cs]: "Turecko",
		[Locale.en]: "Turkey",
	},
	[Country.Turkmenistan]: {
		[Locale.cs]: "Turkmenistán",
		[Locale.en]: "Turkmenistan",
	},
	[Country.Tuvalu]: {
		[Locale.cs]: "Tuvalu",
		[Locale.en]: "Tuvalu",
	},
	[Country.Uganda]: {
		[Locale.cs]: "Uganda",
		[Locale.en]: "Uganda",
	},
	[Country.Ukraine]: {
		[Locale.cs]: "Ukrajina",
		[Locale.en]: "Ukraine",
	},
	[Country.UnitedArabEmirates]: {
		[Locale.cs]: "Spojené arabské emiráty",
		[Locale.en]: "United Arab Emirates",
	},
	[Country.UnitedKingdom]: {
		[Locale.cs]: "Spojené království",
		[Locale.en]: "United Kingdom",
	},
	[Country.UnitedStates]: {
		[Locale.cs]: "Spojené státy",
		[Locale.en]: "United States",
	},
	[Country.Uruguay]: {
		[Locale.cs]: "Uruguay",
		[Locale.en]: "Uruguay",
	},
	[Country.Uzbekistan]: {
		[Locale.cs]: "Uzbekistán",
		[Locale.en]: "Uzbekistan",
	},
	[Country.Vanuatu]: {
		[Locale.cs]: "Vanuatu",
		[Locale.en]: "Vanuatu",
	},
	[Country.VaticanCity]: {
		[Locale.cs]: "Vatikán",
		[Locale.en]: "Vatican City",
	},
	[Country.Venezuela]: {
		[Locale.cs]: "Venezuela",
		[Locale.en]: "Venezuela",
	},
	[Country.Vietnam]: {
		[Locale.cs]: "Vietnam",
		[Locale.en]: "Vietnam",
	},
	[Country.Yemen]: {
		[Locale.cs]: "Jemen",
		[Locale.en]: "Yemen",
	},
	[Country.Zambia]: {
		[Locale.cs]: "Zambie",
		[Locale.en]: "Zambia",
	},
	[Country.Zimbabwe]: {
		[Locale.cs]: "Zimbabwe",
		[Locale.en]: "Zimbabwe",
	},
};
